"use strict";

var StaticForm = {
  $form: undefined,
  onload: document.addEventListener('DOMContentLoaded', function () {
    StaticForm.init();
  }),
  init: function init() {
    this.bind();
  },
  bind: function bind() {
    $(document).on('click', 'button.submit-form', function (event) {
      event.preventDefault();
      var button = $(this);
      StaticForm.$form = button.closest('form[data-type]');
      var type = parseInt(StaticForm.$form.data('type'));
      Main.showPreloader(button);
      if (type === parseInt(FORM_TYPE_MAKE_OFFER)) {
        if (Step.checkDataTimeValidation(button, type)) {
          setTimeout(function () {
            // Main.showPreloader(button);
            StaticForm.ajax.sendForm(button, type, Client.edit, Client.hash);
          }, 451);
        }
      } else if (type === parseInt(FORM_TYPE_BOOKING_PRICE_FIXED) || type === parseInt(FORM_TYPE_BOOKING_PRICE_PER_HOUR) || type === parseInt(FORM_TYPE_EXTEND_OFFER_AMOUNT) || type === parseInt(FORM_TYPE_EXTEND_OFFER_PER_HOUR)) {
        StaticForm.ajax.sendForm($(this), type, Client.edit, Client.hash);
      } else if (type === parseInt(FORM_TYPE_REGISTER_TRAVEL)) {
        StaticForm.ajax.sendForm($(this), type, Client.edit, Client.hash);
      } else {
        StaticForm.ajax.sendForm($(this), type);
      }
    }).on('input paste change', 'form[data-type] [name]', function () {
      StaticForm.hideErrors($(this));
    }).on('click', '[name="feedback-type"]', function () {
      $(this).closest('form').attr('data-type', $(this).val());
    });
  },
  hideErrors: function hideErrors(block) {
    switch (block.attr('name')) {
      case 'driver_vehicle_type':
        block.closest('.type-cars').removeClass('error');
        block.closest('.type-cars').find('.type-cars__error').html('');
        break;
      case 'driver_address':
      case 'driver_lat':
      case 'driver_lng':
      case 'driver_vehicle_name':
      case 'driver_handyman_info':
      case 'driver_vehicle_information':
      case 'client_service':
      case 'client_task_name':
      case 'client_list_of_items':
      case 'client_location_from':
      case 'client_country':
      case 'client_city':
      case 'client_street':
      case 'client_postal_code':
      case 'client_location_to':
      case 'client_lng':
      case 'client_lat':
      case 'client_country_to':
      case 'client_city_to':
      case 'client_street_to':
      case 'client_postal_code_to':
      case 'client_lng_to':
      case 'client_lat_to':
      case 'client_must_haves':
      case 'client_parcel_weight':
      case 'client_pick_up_location':
      case 'client_drop_off_location':
        block.closest('.error').removeClass('error');
        break;
      case 'client_budget':
        block.closest('.error').removeClass('error');
        break;
      case 'driver_timing_days':
      case 'driver_timing_hours':
      case 'driver_how_far_maximum_can_you_transport':
      case 'client_how_traveler_will_get_an_item':
        block.closest('.form-step__group').removeClass('error');
        break;
      case 'driver_i_have_a_valid_driving_license':
      case 'driver_i_have_a_valid_driving_liability':
      case 'driver_i_have_a_valid_handyman_certificates':
      case 'driver_i_have_a_valid_professional_driver_certificates':
        block.closest('.form-step__input').removeClass('form-step__input--checkbox-error');
        break;
      case 'make_offer_amount':
      case 'make_offer_message':
        block.closest('div').removeClass('error');
        block.next().html('');
        break;
      case 'billing_data_offer_id':
      case 'billing_data_first_name':
      case 'billing_data_last_name':
      case 'billing_data_address':
      case 'billing_data_company':
      case 'billing_data_post_code':
      case 'billing_data_city':
      case 'billing_data_country':
        block.closest('.form-billing__input').removeClass('error');
        block.closest('.form-billing__input').find('.form-billing__error').html('');
        break;
      case 'payout_first_name':
      case 'payout_last_name':
      case 'payout_date':
      case 'payout_address_1':
      case 'payout_address_2':
      case 'payout_hsbc':
      case 'payout_post_code':
      case 'payout_country':
      case 'payout_city':
      case 'payout_bank_country':
      case 'payout_iban':
      case 'payout_swift':
      case 'payout_site':
        block.closest('.personal-info-form__input').removeClass('error');
        block.closest('.personal-info-form__input').find('.personal-info-form__error').html('');
        break;
      case 'payout_check':
        block.closest('.personal-info-form__detail').removeClass('personal-info-form__detail-error');
        break;
      case 'profile_first_name':
      case 'profile_last_name':
      case 'profile_country':
      case 'state':
      case 'profile_city':
      case 'profile_street':
      case 'profile_postal_code':
      case 'old-password':
      case 'new-password':
      case 'confirm-password':
        block.closest('.form-element').find('.error').hide().html('');
        break;
      case 'offer_cancel_reason_text':
        block.closest('div').removeClass('error').find('.error').hide().html('');
        break;
      case 'cancel_trip_reason':
        block.closest('div').removeClass('error').find('.form-pop-up__error').hide().text('');
        break;
      case 'captcha':
        block.closest('.captcha').find('.error').show().html('');
        break;
      case 'feedback_client_type':
      case 'feedback_subject':
        block.closest('div.form-feedback__select').removeClass('error').find('.form-feedback__error').text('');
        break;
      case 'feedback_comment':
        block.closest('div.form-feedback__textarea').find('.form-feedback__error').text('');
        break;
      case 'businessVehicleSize':
      case 'businessLatFrom':
      case 'businessLngFrom':
      case 'businessCountryFrom':
      case 'businessAddressFrom':
      case 'businessLatTo':
      case 'businessLngTo':
      case 'businessCountryTo':
      case 'businessAddressTo':
      case 'businessEmail':
      case 'businessFirstName':
      case 'businessMessage':
      case 'businessLastName':
      case 'businessContactTheme':
      case 'businessDate':
        block.closest('div.form-element').find('p.error').text('');
        block.closest('div.form-element').find('p.error').hide();
        break;
      case 'businessHelpHours':
        block.closest('div.calculate-block').next().find('p.error').text('');
        block.closest('div.calculate-block').next().find('p.error').hide();
        break;
      default:
        block.closest('div').find('.error').hide();
        break;
    }
    $('#main-error').html('');
    $('#ai-restriction-error').removeClass('active');
  },
  ajax: {
    obj: {},
    url: AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    sendForm: function sendForm($submitBtn, type) {
      var edit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      this.obj.method = 'sendForm';
      this.obj.typeID = type;
      this.obj.data = StaticForm.$form.serializeArray();
      this.obj.edit = edit;
      this.obj.hash = hash;
      this.send(function (answer) {
        var thankYouPage = $('div.thank-form-step');
        if (type === parseInt(FORM_TYPE_REGISTER_TRAVEL)) {
          $('div.offer__container').hide();
          thankYouPage.css('display', 'flex');
          Step.scrollToTop();
        } else if (type === parseInt(FORM_TYPE_PROFILE_CLIENT_PAYOUT_METHOD_SUBSCRIPTION)) {
          $('.download-offer-popup').removeClass('active');
          Notify.successfulNotification('Saved');
          Profile.ajax.fetchUserBillingInfoBlock();
          Main.hidePreloader($submitBtn);
        } else if (type === parseInt(FORM_TYPE_MAKE_OFFER)) {
          $('.confirmation').show();
          Step.scrollToTop();
          setTimeout(function () {
            window.location.replace(answer.callbackUrl);
          }, 5000);
        } else if (type === parseInt(FORM_TYPE_BOOKING_PRICE_FIXED) || type === parseInt(FORM_TYPE_BOOKING_PRICE_PER_HOUR) || type === parseInt(FORM_TYPE_EXTEND_OFFER_AMOUNT) || type === parseInt(FORM_TYPE_EXTEND_OFFER_PER_HOUR)) {
          $('.confirmation').show();
          Step.scrollToTop();
          setTimeout(function () {
            window.location.replace(answer.callbackUrl);
          }, 1000);
        } else if (type === parseInt(FORM_TYPE_OFFER_DECLINE)) {
          $('input[name="offer_hash"]').val('');
          $('#decline-popup').hide();
          Client.ajax.fetchOfferCard(answer.hash, answer.type);
        } else if (type === parseInt(FORM_TYPE_OFFER_REVIEW)) {
          var reviewPopup = $('#review-popup');
          reviewPopup.hide();
          if (reviewPopup.find('.form-pop-up').attr('data-is-sp') === '1') {
            Client.ajax.showRecommendationPopupWithSpProfile(reviewPopup.find('.form-pop-up').attr('data-sp'));
          }
          Client.ajax.fetchOfferCard(answer.hash, answer.type);
        } else if (type === parseInt(FORM_TYPE_PROFILE_PAYOUT_METHOD)) {
          Notify.successfulNotification(answer.notify);
          Main.hidePreloader($submitBtn);
        } else if (type === parseInt(FORM_TYPE_PROFILE_CLIENT_PAYOUT_METHOD)) {
          $('.download-offer-popup').removeClass('active');
          $(".offer-info-item[id=\"".concat($submitBtn.attr('data-hash'), "\"]")).find('.download-offer-details').click();
          Main.hidePreloader($submitBtn);
        } else if (type === parseInt(FORM_TYPE_PROFILE_CLIENT_PAYOUT_METHOD_INVOICES)) {
          $('.download-offer-popup').removeClass('active');
          $('#download-archive-with-invoices').click();
          Main.hidePreloader($submitBtn);
        } else if (type === parseInt(FORM_TYPE_PROFILE_INFO) || type === parseInt(FORM_TYPE_NOTIFICATIONS_CHANEL_SETTINGS) || type === parseInt(FORM_TYPE_NOTIFICATIONS_SETTINGS)) {
          Notify.successfulNotification(answer.notify);
          Step.scrollToTop();
          Main.hidePreloader($submitBtn);
        } else if (type === parseInt(FORM_TYPE_FEEDBACK) || type === parseInt(FORM_TYPE_BUG)) {
          Main.hidePreloader($submitBtn);
          StaticForm.$form.hide();
          Step.scrollToElement($('div.feedback-form__wraper'));
          StaticForm.$form.next().fadeIn(Main.animationParams);
          StaticForm.$form[0].reset();
          setTimeout(function () {
            StaticForm.$form.fadeIn(Main.animationParams);
            StaticForm.$form.next().hide();
          }, 10000);
        } else if (type === parseInt(FORM_TYPE_BUSINESS_TASK__STEP_1)) {
          Business.switchSteps($submitBtn);
          Main.hidePreloader($submitBtn);
        } else if (type === parseInt(FORM_TYPE_BUSINESS_TASK__STEP_2)) {
          Business.ajax.saveBusinessForm($submitBtn);
        } else if (type === parseInt(FORM_TYPE_EXTERNAL_REVIEW)) {
          window.location.reload();
        } else if (type === parseInt(FORM_TYPE_BUSINESS_CONTACT)) {
          StaticForm.$form[0].reset();
          Main.hidePreloader($submitBtn);
          $('.popup-thank').addClass('active');
          // $('.receive-offer').css('display', 'flex');
          // $('.offer-form').hide();
          // $('.offer-done').css('display', 'flex');

          setTimeout(function () {
            // $('.receive-offer').hide();
            // $('.offer-form').css('display', 'flex');
            // $('.offer-done').hide();
            $('.popup-thank').removeClass('active');
          }, 5000);
        } else {
          $('#contact-us-thanks-popup').fadeIn();
          StaticForm.$form[0].reset();
          $('#w0-image').click();
          setTimeout(function () {
            $('#contact-us-thanks-popup').fadeOut();
          }, 3000);
          Main.hidePreloader($submitBtn);
        }
        if ($('.recaptchaResponse').length) generateCaptcha();
      }, function (answer) {
        $('#w0-image').click();
        if (type === parseInt(FORM_TYPE_MAKE_OFFER) || type === parseInt(FORM_TYPE_OFFER_REVIEW) || type === parseInt(FORM_TYPE_PROFILE_INFO) || type === parseInt(FORM_TYPE_PROFILE_PAYOUT_METHOD)) {
          if (type === parseInt(FORM_TYPE_PROFILE_PAYOUT_METHOD)) Step.scrollToTop();
          if (answer.mainError) $('#main-error').text(answer.mainError);
          if (!answer.phoneVerification) VerifyPhone.openFirstStep();
          if (answer.aiRestriction) {
            $('#ai-restriction-error').addClass('active');
          }
        } else {
          $.each(answer.errors, function (k, v) {
            if (k === 'captcha') {
              StaticForm.$form.find("[name=\"".concat(k, "\"]")).closest('.captcha').find('.error').show().html(v);
            } else {
              StaticForm.$form.find("[name=\"".concat(k, "\"]")).closest('div').find('.error').show().html(v);
            }
          });
        }
        $.each(answer.errors, function (name, value) {
          Step.showErrors(name, value);
        });
        Main.hidePreloader($submitBtn);
        if (type !== parseInt(FORM_TYPE_BUSINESS_TASK__STEP_2) && type !== parseInt(FORM_TYPE_BUSINESS_CONTACT)) {
          if (answer.errors) Step.scrollToError(Object.keys(answer.errors)[0]);
        }
        if (answer.savingError) Notify.dangerNotification(answer.savingError);
        if (type !== parseInt(FORM_TYPE_PROFILE_CLIENT_PAYOUT_METHOD_SUBSCRIPTION)) {
          if (!answer.phoneVerification) VerifyPhone.openFirstStep();
        }
        if ($('.recaptchaResponse').length) generateCaptcha();
      });
    }
  }
};